import LibraryComparison from "components/LibraryComparison";
import * as React from 'react';
export default {
  LibraryComparison,
  React
};